import { useState, useCallback } from 'react';
import { DraftData } from '../../../types/features/Ticket';

const DRAFT_KEY = 'ticket_draft';

export function useTicketDraft() {
  const [draft, setDraft] = useState<DraftData | null>(() => {
    const saved = localStorage.getItem(DRAFT_KEY);
    if (!saved) return null;
    try {
      const data = JSON.parse(saved);
      const age = Date.now() - new Date(data.updated_at).getTime();
      if (age < 24 * 60 * 60 * 1000) return data;
      localStorage.removeItem(DRAFT_KEY);
      return null;
    } catch {
      localStorage.removeItem(DRAFT_KEY);
      return null;
    }
  });

  const saveDraft = useCallback((data: Partial<DraftData>) => {
    setDraft(prev => {
      const newDraft = { ...prev, ...data, updated_at: new Date().toISOString() } as DraftData;
      localStorage.setItem(DRAFT_KEY, JSON.stringify(newDraft));
      return newDraft;
    });
  }, []);

  const clearDraft = useCallback(() => {
    localStorage.removeItem(DRAFT_KEY);
    setDraft(null);
  }, []);

  return {
    draft,
    saveDraft,
    clearDraft,
    hasDraft: draft !== null
  };
}